// ─────────────────────────────────────────────────────────────────────────────
// Nome do arquivo de uma imagem anexada.
//
// A legenda que o operador escreve vira o nome do arquivo no destino — é por
// isso que ela é pedida. Sem legenda, cai em "imagem-1_a1b2c3d4.png".
//
// Estava dentro do AnexoImagens, que deixou de existir quando a imagem passou a
// entrar no meio do texto (ver components/CampoAnotacoes.js). A regra continua
// a mesma, e é a mesma do 1.4.1.
// ─────────────────────────────────────────────────────────────────────────────

/**
 * @param {{ dataUrl?: string, legenda?: string }} img
 * @param {number} indice posição da imagem no envio, para o nome de fallback
 */
export function gerarNomeImagem(img, indice) {
  const mime = (String(img?.dataUrl || '').match(/^data:image\/([a-z0-9.+-]+)/i) || [])[1] || 'png';
  const ext = mime.toLowerCase().replace('jpeg', 'jpg').replace(/[^a-z0-9]/g, '') || 'png';

  // randomUUID exige contexto seguro (https/localhost); o Math.random cobre o
  // resto. A chave evita que duas imagens com a mesma legenda se sobrescrevam
  // no destino.
  const chave = (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
    ? crypto.randomUUID().split('-')[0]
    : Math.random().toString(36).slice(2, 10);

  const slug = String(img?.legenda || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')   // "visão" → "visao"
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);

  return slug ? `${slug}_${chave}.${ext}` : `imagem-${indice + 1}_${chave}.${ext}`;
}
